//import logo from './logo.svg';
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Home from "./components/Home";
//import Products from "./components/Products";
import Services from "./components/Services";
import Customers from "./components/Customers";
import Location from "./components/Location";
import About from "./components/About";
import Shimadzu from "./components/Shimadzu";
import Genuine from "./components/Genuine";
import Pixxgen from "./components/Pixxgen";
import SocialMedia from "./components/SocialMedia";
import Construction from "./components/Construction";
import Gelpad from "./components/Gelpad";
import Portal from "./components/Portal";
import { FaPhoneAlt, FaTools } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import DemoFormModal from "./components/DemoFormModal";

function App() {
  const [showDemoModal, setShowDemoModal] = React.useState(false);

  return (
    <Router>
      <div className="App">
        {/* Modernized Navbar */}
        <Navbar className="navbar-color" expand="lg" variant="light">
          <Navbar.Brand href="/home" className="d-flex align-items-center">
            <img
              className="navbar-logo me-3"
              src="/assets/logos/indelect-logo-nb.png"
              height="120"
              alt="Indelect Logo"
              style={{ borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.10)' }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/home">Home</Nav.Link>
              <NavDropdown title="Products" id="basic-nav-dropdown">
                <NavDropdown.Item href="/shimadzu">Shimadzu</NavDropdown.Item>
                <NavDropdown.Item href="/genuine">Genuine</NavDropdown.Item>
                <NavDropdown.Item href="/pixxgen">Pixxgen</NavDropdown.Item>
                <NavDropdown.Item href="/ctsp">
                  Neuro Surgical Stereotactic Device (CTSP)
                </NavDropdown.Item>
                <NavDropdown.Item href="/gelpads">
                  Surgical Instruments and Gel Pads
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="/services">Services</Nav.Link>
              <Nav.Link href="/customers">Customers</Nav.Link>
              <Nav.Link href="/location">Location</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/portal">Portal</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {/* Improved Contact Section */}
        <section className="home-contact-section">
          <div className="home-contact-item">
            <span className="home-contact-icon" aria-label="Sales"><FaPhoneAlt /></span>
            <span className="contact-title">Sales</span>
            <span className="contact-number">+91 93802 43402</span>
          </div>
          <div className="home-contact-item">
            <span className="home-contact-icon" aria-label="Service"><FaTools /></span>
            <span className="contact-title">Service</span>
            <span className="contact-number">+91 93825 43299</span>
          </div>
          <div className="home-contact-item">
            <span className="home-contact-icon" aria-label="Email"><MdEmail /></span>
            <span className="contact-title">Email</span>
            <span className="contact-email"><a href="mailto:salesindelect@gmail.com">salesindelect@gmail.com</a></span>
          </div>
          <div className="home-contact-item">
            <button
              className="schedule-demo-btn"
              onClick={() => setShowDemoModal(true)}
              style={{
                background: '#007bff',
                color: '#fff',
                fontWeight: 'bold',
                border: 'none',
                borderRadius: '8px',
                padding: '0.7rem 1.5rem',
                fontSize: '1.08rem',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,95,163,0.10)'
              }}
            >
              Schedule Demo
            </button>
          </div>
          <div className="home-contact-item">
            <SocialMedia />
          </div>
          <DemoFormModal show={showDemoModal} onClose={() => setShowDemoModal(false)} />
        </section>
      </div>
      <hr />
      <Switch>
        <Route path="/shimadzu">
          <Shimadzu />
        </Route>
        <Route path="/genuine">
          <Genuine />
        </Route>
        <Route path="/pixxgen">
          <Pixxgen />
        </Route>
        <Route path="/ctsp">
          <Construction />
        </Route>
        <Route path="/gelpads">
          <Gelpad />
        </Route>
        <Route path="/services">
          <Services />
        </Route>
        <Route path="/customers">
          <Customers />
        </Route>
        <Route path="/location">
          <Location />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/portal">
          <Portal />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <hr />
      <footer className="text-center text-lg-start bg-white text-muted mt-4 shadow-sm rounded-top">
  <div className="text-center p-4">
    © 2025
    <a className="text-reset fw-bold ms-2" href="https://www.indelect.com"> www.indelect.com</a>
  </div>
</footer>
    </Router>
  );
}

export default App;
